import { FactoryProvider, InjectionToken } from '@angular/core';
import { Configuration } from '@adesso/dataspace-api-client';
import { environment } from '@htx/environment';

export const ADESSO_API_CONFIG = new InjectionToken<Configuration>('ADESSO_API_CONFIG');

function resolveApiKey(): string {
  const fromEnv = (environment as Record<string, unknown>)['apiKey'];
  return typeof fromEnv === 'string' ? fromEnv : 'password';
}

export const adessoApiConfigProvider: FactoryProvider = {
  provide: ADESSO_API_CONFIG,
  useFactory: (): Configuration =>
    new Configuration({
      basePath: environment.adessoApiUrl,
      apiKey: () => resolveApiKey()
    })
};
